<template>
	<div id="app" :style="{ top: '0px', position: 'static', marginTop: '0px', display: 'flex', flexDirection: 'column', minHeight: '100vh' }">
		<!-- <div
			style="position: fixed;top: 0; z-index: 999; background-color: red;width: 100%;height: 15px;line-height: 15px; text-align: center;font-size: 12px;color: white;font-weight: 600;">
			推荐使用谷歌双核浏览器</div> -->
		<!-- 客服 首页头部 -->
		<div>
<!--			<div id="rightArrow" @click="moveLeftOrRight"-->
<!--				:class="moveFlag?moveLeftRight==='left' ? 'animationLeftExpose':'animationRightExpose':''"-->
<!--				:style="moveFlag?moveLeftRight==='left' ? 'background-position: 0 0;':'background-position: -50px 0;':''">-->
<!--				<a :class="moveFlag?moveLeftRight==='left' ? 'animationLeftMove':'animationLeftMove':''"></a>-->
<!--				<div class="arrowtxt">在线客服</div>-->
<!--			</div>-->
<!--			&lt;!&ndash; 左部客服弹出框 &ndash;&gt;-->
<!--			<div id="floatDivBoxs" :class="moveFlag?moveLeftRight==='left' ? 'animationLeft':'animationRight':''">-->
<!--				<div class="floatDtt">在线客服</div>-->
<!--				<div class="floatShadow">-->
<!--					<ul class="floatDqq">-->
<!--						<li>-->
<!--							<a target="_blank" style="color: black;"-->
<!--								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberOne+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>-->
<!--						</li>-->
<!--						<li>-->
<!--							<a target="_blank" style="color: black;"-->
<!--								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberTwo+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>-->
<!--						</li>-->
<!--						<li>-->
<!--							<a target="_blank" style="color: black;"-->
<!--								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberThree+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>-->
<!--						</li>-->
<!--					</ul>-->
<!--					<div class="floatDtxt">服务热线</div>-->
<!--					<ul class="floatDtel">-->
<!--						<li><span class="icoTl">0351-3620999</span></li>-->
<!--					</ul>-->
<!--				</div>-->
<!--				<div class="floatDbg"></div>-->
<!--			</div>-->
			<!-- 页面头部 -->
			<div ref="header"
				style="position: fixed;z-index: 999;top:0px;right: 0;width: 100%;border: 0;left: 0;background-color: #fff;">
				<ul class="nav	w-1200" style="width: 60%;">
					<!-- <a href="/" style="position: absolute;top:20px;font-weight: bold;font-size: 30px;color:black;">
						<img style="width:60px;height: 60px;line-height: 70px;" src="../../static/img/logo.png">
						职业技能等级认定
					</a> -->

<!--					<div class="zhiye" style="position: absolute; top: 15px;">-->
<!--						&lt;!&ndash; <img src="../../static/img/logo1.png" style="width: 800px;height: 100px;" alt=""> &ndash;&gt;-->
<!--            &lt;!&ndash; 职业技能等级认定 &ndash;&gt;-->
<!--            &lt;!&ndash; <img src="../../static/img/jing.png" style="width: 270px;height: 150px;" alt=""> &ndash;&gt;-->
<!--          </div>-->

					<div style="position: absolute;right: 10px;top:0px;height: 10px;" class="navigaion">
<!--						<li class="m" style="margin-left: 10px;">-->
<!--							<a @mouseover="gzhMouseOver" @mouseleave="gzhMouseLeave"-->
<!--								style="font-size: 17px;color:black;" class="layui-tel" href="javascript:;">-->
<!--								<i class="layui-icon layui-icon-cellphone"></i>-->
<!--								公众号-->
<!--							</a>-->
<!--							<div v-if="gzhFlag" class="hover_wrap"-->
<!--								style="opacity:1;border-radius: 10px; top:75px;position: absolute; left: -70px; z-index: 999;background: #fff;border: 1px solid #ebeef5;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);width: 220px;height: 240px;">-->
<!--								<div>-->
<!--									<div class="arrr f-pa"></div>-->
<!--									<div style="text-align: center;width: 100%;height: 20px;margin-top: 10px;">微信扫一扫-->
<!--									</div>-->
<!--									<div style="width: 180px;height: 180px;margin: 0 auto">-->
<!--										<img src="../../static/img/gongzhong.jpg" style="width: 100%;height: 100%;">-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</li>-->
					<li class="m" style="margin-left: 30px;">
						<a @click="$router.push('/login')" href="javascript:;" style="font-size: 17px;color:black;" v-if="this.$storage.get('declareUser') == undefined">
							<i class="layui-icon layui-icon-username"></i>
							登录
						</a>

							<el-dropdown @command="loginHandleCommand1"
								v-if="this.$storage.get('declareUser') != undefined">
								<a href="javascript:;" style="font-size: 17px;color:black;">
									<i class="layui-icon layui-icon-username"></i>
									{{this.$storage.get('declareUser').userName}}<i
										class="el-icon-arrow-down el-icon--right"></i>
								</a>
								<el-dropdown-menu>
									<el-dropdown-item command="a" style="text-align: center;">个人信息
									</el-dropdown-item>
									<el-dropdown-item command="b" style="text-align: center;">退出</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</li>
					<li v-if="this.$storage.get('declareUser') == null && this.$storage.get('declareUser') == undefined"
						class="m" style="margin-left: 30px;">
						<a @click="$router.push('/personRegister')" href="javascript:;" class="login" style="font-size: 17px;color:black;">
							<i class="layui-icon layui-icon-username"></i>
							注册
						</a>
					</li>
					</div>
				</ul>
			</div>
		</div>
		<!-- 页面导航栏 -->
		<div :style="'background-color: #0977E8;z-index: 10;width: 100%;margin: 0 auto;position: fixed;height: 50px;top: '+ headerHeight + 'px;'">
			<ul class="nav	w-1200" style="display: flex;justify-content: center;align-items: center;">
				<!-- 首页 -->
				<li class="m">
					<h3>
						<router-link to="/" class="nav-f" style="font-size: 16px;">首页</router-link>
					</h3>
				</li>
			<!-- 在线办理 -->
        <!--
			<li class="m">
				<el-dropdown placement="bottom">
					<h3>
						<a class="nav-f" style="font-size: 16px;">在线办理</a>
					</h3>
					<el-dropdown-menu>
						<el-dropdown placement="left" @command="zaixianbanli">
							<el-dropdown-item>申报</el-dropdown-item>
							<el-dropdown-menu>
								<el-dropdown-item v-for="(item,index) in wangbaoList" :key="index" :command="item.level">{{item.title}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>

						<el-dropdown placement="right" @command="cahxun">
							<el-dropdown-item>查询</el-dropdown-item>
							<el-dropdown-menu>
								<el-dropdown-item v-for="(item,index) in chaxunlist" :key="index" :command="item.level">{{item.title}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			-->
			<!-- 成绩查询 -->
			<li class="m">
				<h3>
					<a v-on:click="goToScoreQuery()" class="nav-f" style="font-size: 16px;">成绩查询</a>
				</h3>
			</li>
				<!-- 新闻公告 -->
        <!--
				<li class="m">
					<el-dropdown slot="dropdown" @command="xinwengonggao">
						<h3><a class="nav-f" style="font-size: 16px;">新闻公告</a></h3>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="a">新闻中心</el-dropdown-item>
							<el-dropdown-item command="b">通知公告</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</li>
         -->
				<!-- 教育培训 -->
        <!--
				<li class="m">
					<el-dropdown slot="dropdown" @command="jiaoyupeixun">
						<h3><a id="kaoshi" class="nav-f" style="font-size: 16px;">教育培训</a></h3>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="a">报名须知</el-dropdown-item>
							<el-dropdown-item command="b">招生简章</el-dropdown-item>
							<el-dropdown-item command="c">政策支持</el-dropdown-item>
							<el-dropdown-item command="d">职业标准</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</li>
				 -->
			<!-- 技能培训 -->
			<li class="m">
				<h3><a v-on:click="navigation(7)" id="kaoshi" class="nav-f">技能培训</a></h3>
			</li>
			<!-- 技能考试 -->
				<li class="m">
					<h3><a v-on:click="navigation(8)" id="kaoshi" class="nav-f">技能考试</a></h3>
				</li>
				<!-- 关于我们 -->
				<!--
				<li class="m">
					<h3><a v-on:click="guanyuwomen()" id="kaoshi" class="nav-f">关于我们</a></h3>
				</li>
				-->

				<!-- <li class="m">
					<h3><a v-on:click="navigation(9)" id="kaoshi" class="nav-f">综改区报名</a></h3>
				</li>
				<li class="m">
					<h3><a v-on:click="navigation(10)" id="kaoshi" class="nav-f">产业集群培训</a></h3>
				</li> -->
				<!-- <li class="m">
					<h3><a v-on:click="navigation(11)" id="kaoshi" class="nav-f">无人机培训</a></h3>
				</li> -->
			</ul>
		</div>
		<!-- 占位，避免内容被固定头部和导航遮挡 -->
		<div :style="'height:' + (headerHeight + 50) + 'px'"></div>
		<div style="flex: 1; display: flex; flex-direction: column;">
			<router-view :key="$route.params.navId" style="margin-top: 0; flex: 1;"></router-view>
		</div>
		<div v-loading.fullscreen.lock="fullscreenLoading"></div>
		<end></end>
		<el-backtop>
		</el-backtop>
		<!-- <div id="adbox" ref="adbox" v-show="showAdbox" @mouseenter="enterbox" @mouseleave="leavebox"
			style="cursor: pointer;">
			<p style="overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis" @click="detail()">{{slideshowVo.contentTitle}}</p>
			<b @click="closebox">×</b>
		</div> -->
	</div>
</template>
<script>
	//import homePage from './components/homePage.vue';
	import End from './end.vue';
	export default {
		name: 'app',
		components: {
			End
		},
		data() {
			return {
 					headerHeight: 0,
				chaxunlist: [{
                    title: '成绩查询',
                    level: 1
                },
                {
                    title: '证书查询',
                    level: 2
                },
                {
                    title: '国家职业技能标准',
                    level: 3
                },
                {
                    title: '国家职业资格目录',
                    level: 4
                },
                {
                    title: '技能人才信息平台',
                    level: 5
                }],
				wangbaoList: [{
                    title: '五级-初级工',
                    className: 'js5',
                    level: 5
                },
                {
                    title: '四级-中级',
                    className: 'js4',
                    level: 4
                },
                {
                    title: '三级-高级',
                    className: 'js3',
                    level: 3
                },
                {
                    title: '技师',
                    className: 'js2',
                    level: 2
                },
                {
                    title: '高级技师',
                    className: 'js1',
                    level: 1
                }],
				fullscreenLoading: false,
				NavigationLists: [
					{
						state: 2,
						url: '/',
						name: '首页'
					},
					{
						state: 1,
						url: '',
						name: '在线办理'

					},
					{
						state: 1,
						url: '/journalismNotice/1',
						name: '报名须知'

					}, {
						state: 1,
						url: '/journalismNotice/7',
						name: '招生简章'

					},
					{
						state: 1,
						url: '/journalismNotice/2',
						name: '政策文件'

					},
					{
						state: 1,
						url: '/journalismNotice/3',
						name: '实时新闻'
					},
					{
						state: 1,
						url: '/journalismNotice/4',
						name: '通知公告'
					},
					{
						state: 1,
						url: '/journalismNotice/5',
						name: '关于我们'
					},
					{
						state: 1,
						url: '/journalismNotice/6',
						name: '职业标准'
					}],
				gzhFlag: false,
				navigationName: '',
				flag: 0,
				drawer: false,
				moveFlag: false,
				moveLeftRight: '',
				declareUser: {},
				slideshowVo: {},
				x: 50,
				y: 50,
				xin: true,
				yin: true,
				step: 1,
				delay: 10,
				itl: null,
				showAdbox: true,
			}
		},
		/* beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.routeEnterShowAdbox();
			})
		}, */
		beforeRouteLeave(to, from, next) {
			next(vm => { });
			clearInterval(this.itl);
		},
		created() {
			//默认加载 通知公告
			this.HandoverNotificationOrPresscenterDataLoad(29);

			//this.$watermark({watermark_txt:"职业技能等级认定"})
		},
		mounted() {
			this.updateHeaderHeight();
			window.addEventListener('resize', this.updateHeaderHeight);
		},
        beforeDestroy(){
            window.removeEventListener('resize', this.updateHeaderHeight);
        },
		watch: {
			'$route': function (to, from) {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			}
		},
		methods: {
				updateHeaderHeight(){
					this.$nextTick(()=>{
						if(this.$refs.header){
							this.headerHeight = this.$refs.header.offsetHeight || 0;
						}
					})
				},
			guanyuwomen(){
				this.$router.push("/aboutUs")
			},
			a(){
				this.$router.push("/journalismNotice/5")


			},
			jiaoyupeixun(a){
				if(a == 'a'){
					//报名须知
					this.$router.push("/journalismNotice/1")
				}else if(a =='b'){
					//招商简章
					this.$router.push("/journalismNotice/7")
				}else if(a =='c'){
					//政策支持
					this.$router.push("/journalismNotice/2")
				}else if(a == 'd'){
					//职业标准
					this.$router.push("/journalismNotice/6")
				}
			},
			xinwengonggao(a){

				if(a == 'a'){
					//新闻中心
					this.$router.push("/journalismNotice/3")
				}else{
					//通知公告
					this.$router.push("/journalismNotice/4")
				}

			},
			cahxun(level){

				if(level == 1){
					 //成绩查询
					 this.$router.push({ path: '/scoreInquire' })
				}else if(level == 2){
					 //证书查询
					 this.$router.push({ path: '/certificateInquire' })
				}else if(level == 3){
					window.open("http://zybz.class.com.cn/")
				}else if(level == 4){
					window.open("http://www.mohrss.gov.cn/SYrlzyhshbzb/SYgundongxinwen/201710/t20171024_280005.html")
				}else if(level == 5){
					window.open("http://pjjg.osta.org.cn")
				}

			},
			zaixianbanli(level) {
                if (this.$storage.get('declareUser') != null && this.$storage.get('declareUser') != undefined) {
                    this.$router.push({ path: '/affirm/' + level + "/1" });
                } else {
                    this.$router.push({ path: '/login' });
                }
            },
			closebox() {
				this.showAdbox = false;
				clearInterval(this.itl)
			},
			enterbox() {
				clearInterval(this.itl)
			},
			movebox() {
				var L = 0;
				var T = 0;
				var R = document.documentElement.clientWidth - this.$refs.adbox.offsetWidth;    //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
				var B = document.documentElement.clientHeight - this.$refs.adbox.offsetHeight;  //浏览器显示高度-adbox高度，不随滚动条变化而变化
				this.$refs.adbox.style.left = this.x + document.documentElement.scrollLeft + "px";  //adbox初始左+滚动条最左端到浏览器最左端的距离
				this.$refs.adbox.style.top = this.y + document.documentElement.scrollTop + "px";    //adbox初始高+滚动条顶端到浏览器顶端的距离
				this.x = this.x + this.step * (this.xin ? 1 : -1);
				if (this.x < L) { this.xin = true; this.x = L; }
				if (this.x > R) { this.xin = false; this.x = R; }
				this.y = this.y + this.step * (this.yin ? 1 : -1);
				if (this.y < T) { this.yin = true; this.y = T; }
				if (this.y > B) { this.yin = false; this.y = B; }
			},
			routeEnterShowAdbox() {
				this.itl = setInterval(this.movebox, this.delay)
			},
			HandoverNotificationOrPresscenterDataLoad(navId) {
				//加载 首页 数据
				let parames = new URLSearchParams();
				parames.append('navId', navId); //id 类型id
				parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

				this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

					if (resp.data.data.length > 0) {

						resp.data.data.forEach((element, index) => {


							//轮播图 最多三条
							if (index < 1) {
								let slideshowVo = {
									id: 0,
									navName: 0,
									src: '',
									contentTitle: '',
									insertTime: ''
								}

								slideshowVo.id = element.id;
								slideshowVo.navName = element.navName;
								slideshowVo.contentTitle = element.contentTitle;

								this.slideshowVo = slideshowVo;

							}
						})

					}
				}).catch(err => {
					this.$message({
						showClose: true,
						message: '服务器繁忙,请稍后再试!',
						type: 'error'
					})
				})
			},
			detail() {
				this.$router.push({ path: '/journalismNoticeDetail/' + this.slideshowVo.id + "/" + this.slideshowVo.navName })

				this.showAdbox = false;
			},
			navigationSwitchover(index) {
				this.NavigationLists.forEach(element => {
					if (element.state == 2) {
						element.state = 1;
					}
				});
				this.NavigationLists[index].state = 2;
			},
			//注册
			registerHandleCommand(command) {
				if (command === 'a') {
					this.$router.push('/personRegister')
				} else {
					this.$router.push('/unitRegister')
				}
			},
			//登录
			loginHandleCommand(command) {
				if (command === 'a') {
					this.$router.push('/login')
				} else {
					// 使用动态获取的管理员登录URL
					window.location.href = this.adminLoginUrl;
				}
			},
			//登录后
			loginHandleCommand1(command) {
				if (command === 'a') {
					this.$router.push({ path: '/personalInformation/5/1' })
				}
				if (command === 'b') {


					let parames = new URLSearchParams();
					parames.append('userId', this.$storage.get("declareUser").id);
					this.$axios.post(this.serverUrl + '/logout', parames).then(resp => {

						//个人
						console.log('清除前的token==========' + this.$storage.get('token'));
						console.log('清除前的declareUser==========' + this.$storage.get('declareUser'));
						//退出登录
						this.$storage.remove('token');
						this.$storage.remove('declareUser');
						this.$storage.remove('one_pa');
						console.log('清除完后的token==========' + this.$storage.get('token'));
						console.log('清除完后的declareUser==========' + this.$storage.get('declareUser'));


						this.$router.push('/login');

					}).catch(err => {

					})


				}
			},
			key() {
				return new Date().getTime;
			},
			//客服左移右移
			moveLeftOrRight() {
				//this.drawer=true;
				if (this.moveLeftRight === '') {
					this.moveLeftRight = 'left';
				} else if (this.moveLeftRight === 'left') {
					this.moveLeftRight = 'right';
				} else {
					this.moveLeftRight = 'left';
				}
				this.moveFlag = true;//开启动画
			},
			//导航方法
			navigation(data) {
				if (data === 7) {
					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						//技能培训
						this.$router.push({ path: '/train' });
					}
				} else if (data === 8) {
					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						this.fullscreenLoading = true;
						//技能考试
						let parames = new URLSearchParams();
						parames.append('userId', this.$storage.get("declareUser").id);
						let ArrayList = [];
						this.$axios.post(this.serverUrl + '/ex/examList', parames).then(resp => {
							//能进来此接口就一定有考试信息 直接循环获取
							if (resp.data.data.length > 0) {

								this.fullscreenLoading = false;
								//技能考试
								this.$router.push({ path: '/examHomePage' });

							} else {
								this.fullscreenLoading = false;
								this.$message({
									showClose: true,
									message: '暂无考试！',
									type: 'warning',
									offset: 300,
									center: true

								})
							}
						}).catch(err => {

						})
					}
				} else if (data === 9) {
					//综改区报名
					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						this.$router.push({ path: '/HeddleChangeArea' });
					}
				} else if (data === 10) {

					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						//产业集群培训
						//查询该用户存在不存在
						let parames = new URLSearchParams();
						let str = this.$storage.get("declareUser").idCard;
						parames.append('idCard', str);
						this.$axios.post(this.TechServerUrl + '/user/checkUserIdCard', parames).then(resp => {
							if (resp.data.code === 1) {
								//存在
								//window.location.href = "https://tech.zcyunedu.com/lg/ts?i=" + str.substring(str.length - 10);

								window.location.href = "https://zcyunzj.com/#/login";

							} else {
								//不存在 去注册再跳转
								let parames = new URLSearchParams();
								parames.append('userName', this.$storage.get("declareUser").userName);
								parames.append('idCard', this.$storage.get("declareUser").idCard);
								parames.append('telephone', this.$storage.get("declareUser").telephone);
								parames.append('email', this.$storage.get("declareUser").email);
								parames.append('password', this.$storage.get("declareUser").password);
								this.$axios.post(this.TechServerUrl + '/lg/registerjnUser', parames).then(resp => {
									if (resp.data.code === 3) {
										//注册成功
										window.location.href = "https://zcyunzj.com/#/login";
									} else {
										this.$message({
											showClose: true,
											message: '服务器异常！',
											type: 'warning',
											offset: 300,
											center: true
										})
									}
								}).catch(err => {
									this.$message({
										showClose: true,
										message: '服务器异常！',
										type: 'warning',
										offset: 300,
										center: true
									})
								})
							}
						}).catch(err => {
						})
					}

				} else if (data === 11) {

					//无人机培训

					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {

						console.log("userId====" + this.$storage.get("declareUser").id);


						console.log("one_pa=======" + this.$storage.get("one_pa"));
						let parames = new URLSearchParams();
						parames.append('userId', this.$storage.get("declareUser").id);
						parames.append('one_pa', this.$storage.get("one_pa"));
						this.$axios.post(this.serverUrl + '/qs/yyzz', parames).then(resp => {
							if (resp.data.code === 1) {
								//存在
								//window.location.href = resp.data.url;
								window.open(resp.data.url, "_blank");
							} else {
								this.$message({
									showClose: true,
									message: '暂无培训权限！',
									type: 'warning',
									offset: 300,
									center: true
								})
							}
						}).catch(err => {
						})
					}

				}
			},
		//公众号鼠标移入
		gzhMouseOver() {
			this.gzhFlag = true;
		},
		//公众号鼠标移出
		gzhMouseLeave() {
			this.gzhFlag = false;
		},
		//成绩查询
		goToScoreQuery() {
			// 跳转到成绩查询页面
			// 可以根据实际需求修改跳转路径或查询方式
			this.$router.push({ path: '/scoreInquire' });
		},
	}
}
</script>

<style scoped>
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: #0828eb;
		color: #66b1ff;
	}

	.el-dropdown-menu {
		position: absolute;
		top: 0;
		left: 0;
		padding: 10px 0;
		margin: 5px 0;
		background-color: #3457f5;
		border: 0px solid #EBEEF5 !important;
		border-radius: 4px;
		color: white;
		-webkit-box-shadow: 0 0px 0px 0 rgb(0 0 0 / 10%);
		box-shadow: 0 0px 0px 0rgba(0, 0, 0, .1);
	}

	.el-dropdown-menu__item {
		list-style: none;
		line-height: 36px;
		padding: 0 20px;
		margin: 0;
		font-size: 14px;
		color: rgb(255, 255, 255) !important;
		cursor: pointer;
		outline: 0;
	}

	.nav li+li {
		margin-left: 77px;
	}

	#floatDivBoxs {
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}

	#floatDivBoxs .floatDqq li {
		height: 45px;
		line-height: 45px;
		font-size: 15px;
		border-bottom: 1px solid #e3e3e3;
		padding: 0 0 0 36px;
		background: url(../../static/img/qq.gif) no-repeat left center;
	}

	#adbox {
		width: 500px;
		height: auto;
		background-color: #7ac5ff;
		position: absolute;
		z-index: 999;
		color: white;
		padding: 20px;
		font-size: 15px;

	}

	#adbox img {
		border: none;
	}

	#adbox b {
		position: absolute;
		right: 5px;
		top: 0;
		cursor: pointer;
		color: #666;
	}

	.floatDbg {
		width: 120px;
		height: 20px;
		background: url(../../static/f/img/online_botbg.jpg) no-repeat;
	}

	.floatDtt {
		width: 120px;
		height: 45px;
		line-height: 45px;
		background: #00aeef;
		color: #fff;
		font-size: 18px;
		text-indent: 22px;
		position: relative;
	}

	#rightArrow {
		right: 120px;
		width: 50px;
		height: 145px;
		background: url(../../static/f/img/online_arrow.jpg) no-repeat;
		position: fixed;
		top: 180px;
		right: -5px;
		z-index: 9999;

	}

	#floatDivBoxs {
		right: 0px;
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}


	.animationLeftMove {
		animation: rotation 0.5s linear;
	}

	@keyframes rotation {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(180deg);
		}
	}

	.animationLeftExpose {
		animation: moveLeftExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRightExpose {
		animation: moveRightExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	@keyframes moveLeftExpose {
		from {
			right: 0px;
		}

		to {
			right: 120px;
		}
	}

	@keyframes moveRightExpose {
		from {
			right: 120px;
		}

		to {
			right: 0px;
		}
	}

	.animationLeft {
		animation: moveLeft 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRight {
		animation: moveRight 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	@keyframes moveLeft {
		from {
			right: -120px;
		}

		to {
			right: 0px;
		}
	}

	@keyframes moveRight {
		from {
			right: 0px;
		}

		to {
			right: -120px;
		}
	}

	.a {
		position: absolute;
		left: 0;
		top: 65px;
		min-width: 100%;
		line-height: 36px;
		padding: 5px 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
		border: 1px solid #d2d2d2;
		background-color: #fff;
		z-index: 100;
		border-radius: 2px;
		white-space: nowrap;
	}

	.bd {
		margin: 0 auto;
		width: 100% !important;
		position: relative;
		z-index: 0;
	}

	.mian {
		min-width: 1200px;
		padding-top: 15px;
	}

	.page_box {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
		clear: both;
	}

	.page_box_right {
		width: 1200px;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
	}

	#fitslist {
		padding: 0 15px;
		min-height: 400px;
	}

	#fitslist .index_6_2_1_4 {
		width: 100%;
		height: 110px;
		padding-bottom: 25px;
		border-bottom: #eeeeee solid 1px;
		margin-top: 15px;
		float: left;
	}

	#fitslist .index_6_2_1_4_2 {
		width: 980px;
		height: 110px;
		padding: 0 15px;
		float: left;
		line-height: 110px;
	}

	.clearfix {
		display: block;
		clear: both;
	}

  @font-face {
    font-family: 'MyCustomFont'; /* 自定义字体名称 */
    src: url('../assets/AlimamaDongFangDaKai-Regular.ttf') format('truetype'); /* 字体文件路径 */
    font-weight: normal; /* 可选：设置字重 */
    font-style: normal;  /* 可选：设置字体样式 */
  }

  .zhiye{
    font-family: 'MyCustomFont', sans-serif; /* 回退到 sans-serif */
    color: #0e3384;
    font-size: 50px;
    font-weight: 400;
    line-height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue